import { SlideTitleHeaderProps } from './types';

export const SlideTitleHeader = ({ slideHeader }: SlideTitleHeaderProps) => <th className="w-1/5 px-2 pb-4 text-sm text-left">{slideHeader}</th>;
